export class McIcon extends HTMLElement {
  /** @type {SVGElement} **/
  svg;

  /** @type {Map<string, SVGElement>} **/
  state;

  /** @type {HTMLTemplateElement} **/
  template = document.createElement("template");

  /** @type {boolean} **/
  hasStates;

  constructor(hasStates) {
    super();
    this.attachShadow({ mode: "open" });
    this.hasStates = hasStates;
    this.style.display = "block";
  }

  static get observedAttributes() {
    return ["width", "stroke", "height", "state"];
  }

  attributeChangedCallback(name, ov, nv) {
    switch (name) {
      case "width":
        this.svg.style.width = nv;
        break;
      case "height":
        this.svg.style.height = nv;
        break;
      case "stroke":
        this.svg.style.stroke = nv;
        break;
      case "state":
        if (ov == nv) return;
        if (this.state == null || this.state == undefined) return;

        let newstate = this.state.get(nv);
        if (!newstate) return;

        const current = this.shadowRoot.querySelector("svg");
        //NOTE: comment out code was an attempt at animating the change
        // const from = current.querySelectorAll("path")
        // const to = newstate.querySelectorAll("path")
        //
        // let passes = 0
        // from.forEach((p, idx) => {
        //   const fromd = p.getAttribute("d")
        //   const tod = to[idx].getAttribute("d")
        //   p.animate([
        //     { d: `path('${fromd}')` },
        //     { d: `path('${tod}')` }
        //   ],
        //     { duration: 1000 * 2, easing: "ease-in-out", fill: "forwards" })
        //   passes = idx
        // })
        //
        // if (to.length > passes) {
        //   for (let i = passes; i < to.length; i++) {
        //     current.append(to[i])
        //   }
        // }

        // this.template.innerHTML = newstate
        this.shadowRoot.replaceChildren(newstate);
        break;
    }
  }

  /**@param {HTMLTemplateElement} temp **/
  addHTML(temp) {
    if (!this.hasStates) {
      this.shadowRoot.append(temp.content.cloneNode(true));
      this.svg = this.shadowRoot.querySelector("svg");
      return;
    }

    this.shadowRoot.append(this.state.get("default"));
  }
}

if (!window.customElements.get("mc-icon")) {
  window.customElements.define("mc-icon", McIcon);
}
